import loginModule from '../loginModule.js';

function loginForm() {
  return {
    restrict: 'A',
    replace: false,
    templateUrl: 'login-form',
    controller: 'loginFormController',
    scope: {},
    link: function link(scope, element, attrs) {
      scope.loginParams = {
        context: attrs.context,
        redirectToLoginPageOnError: attrs.redirectToLoginPageOnError === 'true',
        redirectToHomePostLogin: attrs.redirectToHomePostLogin === 'true',
        redirectToLoginPageWhenUsernameIsRequired:
          attrs.redirectToLoginPageWhenUsernameIsRequired === 'true',
        isFacebookSignInEnabled: attrs.isFacebookSignInEnabled === 'true',
        useFacebookRedirect: attrs.useFacebookRedirect === 'true',
        includeMessageBanner: attrs.includeMessageBanner === 'true',
        returnUrl: attrs.returnUrl
      };
    }
  };
}

loginModule.directive('loginForm', loginForm);

export default loginForm;
